import { combineReducers, configureStore, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { persistStore, FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

import { AccountsSlice } from '../../accounts/slices/accounts/accounts.slice.ts';
import { AuthSlice } from '../../accounts/slices/auth/auth.slice.ts';
import { EnvironmentSlice } from '../../environment/slices/environment/environment.slice.ts';
import { FeedbackSlice } from '../../feedback/slices/feedback/feedback.slice.ts';
import { ActivityTrackingSlice } from '../../learn/slices/activity-tracking/activity-tracking.slice.ts';
import { AppStateSlice } from '../../learn/slices/app-state/app-state.slice.ts';
import { BallSlice } from '../../learn/slices/ball/ball.slice.ts';
import { LessonSlice } from '../../learn/slices/lesson/lesson.slice.ts';
import { ProgressSlice } from '../../learn/slices/progress/progress.slice.ts';
import { ScriptsSlice } from '../../learn/slices/scripts/scripts.slice.ts';
import { SoundsWritingSlice } from '../../learn/slices/sounds-writing/sounds-writing.slice.ts';
import { StoryReadingSlice } from '../../learn/slices/story-reading/story-reading.slice.ts';

import { AppLifecycleSlice } from '../slices/app-lifecycle/app-lifecycle.slice.ts';
import { AppRedirectionSlice } from '../slices/app-redirection-slice/app-redirection.slice.ts';

export const rootReducer = combineReducers({
  appLifecycle: AppLifecycleSlice,
  appRedirection: AppRedirectionSlice,
  environment: EnvironmentSlice,
  accounts: AccountsSlice,
  auth: AuthSlice,
  appState: AppStateSlice,
  lesson: LessonSlice,
  progress: ProgressSlice,
  ball: BallSlice,
  feedback: FeedbackSlice,
  soundsWriting: SoundsWritingSlice,
  scripts: ScriptsSlice,
  storyReading: StoryReadingSlice,
  activityTracking: ActivityTrackingSlice,
});

export const MainStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        disableCache: false,
      },
    }),
});

export const MainPersistStore = persistStore(MainStore);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof MainStore.dispatch;
export type MainStoreType = typeof MainStore;

interface AsyncThunkConfig {
  state?: unknown;
  dispatch?: ThunkDispatch<unknown, unknown, UnknownAction>;
  extra?: unknown;
  rejectValue?: unknown;
  serializedErrorType?: unknown;
  pendingMeta?: unknown;
  fulfilledMeta?: unknown;
  rejectedMeta?: unknown;
}

export interface ThunkApiConfigType extends AsyncThunkConfig {
  state: RootState;
}
